<template>
  <div class="content">
    <div class="ending">
      <img
        v-scroll-animate="'animate__fadeIn'"
        src="@/assets/images/u36.png"
        alt="Ending Image"
      >
    </div>
  </div>
</template>

<script>
export default {
    name: "EndingView"
};
</script>

<style lang="scss" scoped>
.content {
  background: $backgroundSoft;
}

.ending {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.ending img {
  width: 100vw;
  max-width: 100%;
  height: auto;
  display: block;
}

@media all and (max-width: 1060px) {
  .ending img {
    height: 300px;
    object-fit: cover;
    object-position: center;
  }
 }
</style>
